import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('@/views/change-password/index.vue'),
    meta: { title: '修改初始密码', requiresAuth: true }
  },
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', requiresAuth: true }
      },
      {
        path: 'article/:id',
        name: 'ArticleDetail',
        component: () => import('@/views/article/index.vue'),
        meta: { title: '文章详情', requiresAuth: true }
      },
      {
        path: 'schedule',
        name: 'Schedule',
        component: () => import('@/views/schedule/index.vue'),
        meta: { title: '我的课表', requiresAuth: true }
      },
      {
        path: 'homework',
        name: 'Homework',
        component: () => import('@/views/homework/index.vue'),
        meta: { title: '我的作业', requiresAuth: true }
      },
      {
        path: 'homework/submit/:id',
        name: 'HomeworkSubmit',
        component: () => import('@/views/homework/submit.vue'),
        meta: { title: '提交作业', requiresAuth: true }
      },
      {
        path: 'score',
        name: 'Score',
        component: () => import('@/views/score/index.vue'),
        meta: { title: '我的成绩', requiresAuth: true }
      },
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('@/views/notice/index.vue'),
        meta: { title: '通知公告', requiresAuth: true }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/index.vue'),
        meta: { title: '个人中心', requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} - 陕西MBA教务管理系统` : '陕西MBA教务管理系统'
  
  const token = localStorage.getItem('student_token')
  const needChangePwd = localStorage.getItem('need_change_pwd')
  
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    // 已登录：未完成强制改密的先改密，否则进首页
    next(needChangePwd ? '/change-password' : '/')
  } else if (token && needChangePwd && to.path !== '/change-password' && to.path !== '/login') {
    // 未修改初始密码：拦截一切业务页面
    next('/change-password')
  } else {
    next()
  }
})

export default router
